<script lang="ts">
	// Dimensions constrained by spec
	export let width: number = 130;
	export let height: number = 80;
	export let className: string = "";

	// Font Awesome overlays (solid, black only)
	export let startIconClass: string = "fa-solid fa-location-dot"; // London
	export let endIconClass: string = "fa-solid fa-location-dot";   // Cape Town
	export let routeIconClass: string = "fa-solid fa-bicycle";      // Cycling motif

	// Text controls
	export let titleText: string = "London to Cape Town";
	export let distanceText: string = "~19,000 km";
</script>

<div class="relative" style={`width:${width}px;height:${height}px;`}>
	<svg
		{width}
		{height}
		viewBox="0 0 130 80"
		xmlns="http://www.w3.org/2000/svg"
		role="img"
		aria-label="London to Cape Town cycling passport stamp"
		class={className}
	>
		<title>London to Cape Town Cycling Passport Stamp</title>

		<defs>
			<!-- Rounded-rect path used for inset dashed rule -->
			<rect id="innerRR" x="8" y="8" width="114" height="64" rx="10" ry="10" />

			<!-- Shallow top arc for title text -->
			<path id="titleArc" d="M 18 26 Q 65 10 112 26" />

			<!-- Faint ink spread arc behind title -->
			<path id="inkArc" d="M 14 24 Q 65 6 116 24" />

			<!-- Cardinal tick positions: simple lines drawn directly -->
		</defs>

		<!-- Outer rounded-rectangle border -->
		<rect x="5" y="5" width="120" height="70" rx="12" ry="12" fill="none" stroke="#000" stroke-width="2" />

		<!-- Corner chamfer accents (short 45° hatches) -->
		<g stroke="#000" stroke-width="1" opacity="0.85" stroke-linecap="round">
			<!-- top-left -->
			<path d="M 11 15 L 16 10" />
			<!-- top-right -->
			<path d="M 114 10 L 119 15" />
			<!-- bottom-left -->
			<path d="M 11 65 L 16 70" />
			<!-- bottom-right -->
			<path d="M 114 70 L 119 65" />
		</g>

		<!-- Tiny semicircular notches at mid-sides (ticket-stub vibe) -->
		<g fill="none" stroke="#000" stroke-width="1.2" opacity="0.9">
			<!-- left side notch -->
			<path d="M 5 40 a 3 3 0 0 0 6 0" />
			<!-- right side notch -->
			<path d="M 125 40 a 3 3 0 0 1 -6 0" />
			<!-- top side notch -->
			<path d="M 65 5 a 3 3 0 0 1 0 6" />
			<!-- bottom side notch -->
			<path d="M 65 75 a 3 3 0 0 0 0 -6" />
		</g>

		<!-- Inner dashed inset border following same shape -->
		<use href="#innerRR" fill="none" stroke="#000" stroke-width="1" stroke-dasharray="3 2" opacity="0.9" />

		<!-- Cardinal tick marks on the dashed inset (N/E/S/W) -->
		<g stroke="#000" stroke-width="1" opacity="0.9" stroke-linecap="round">
			<!-- N -->
			<path d="M 65 8 L 65 11" />
			<!-- E -->
			<path d="M 122 40 L 119 40" />
			<!-- S -->
			<path d="M 65 72 L 65 69" />
			<!-- W -->
			<path d="M 8 40 L 11 40" />
		</g>

		<!-- Faint ink spread arc behind the title -->
		<use href="#inkArc" fill="none" stroke="#000" stroke-width="6" opacity="0.07" stroke-linecap="round" />

		<!-- Title along arc -->
		<text fill="#000" font-size="8" font-weight="900" letter-spacing="0.5" text-anchor="middle" style="paint-order: stroke fill; stroke: #000; stroke-width: 0.5;">
			<textPath href="#titleArc" startOffset="50%">{titleText.toUpperCase()}</textPath>
		</text>

		<!-- Gentle curved route from NW to SE -->
		<path d="M 24 38 Q 65 46 106 52" fill="none" stroke="#000" stroke-width="1.2" opacity="0.35" stroke-linecap="round" />

		<!-- Bottom distance line -->
		<g transform="translate(65,56)">
			<text x="0" y="0" fill="#000" font-size="8.2" font-weight="800" text-anchor="middle" style="letter-spacing:0.8px;">• {distanceText} •</text>
			<text x="0" y="9.5" fill="#000" font-size="6.2" font-weight="600" text-anchor="middle" opacity="0.65" style="letter-spacing:1px;">UK • South Africa</text>
		</g>

		<!-- Tiny compass/star accent -->
		<g transform="translate(20,60) scale(0.9)" opacity="0.15" fill="#000">
			<path d="M 0 -4 L 1.2 -1.2 L 4 0 L 1.2 1.2 L 0 4 L -1.2 1.2 L -4 0 L -1.2 -1.2 Z" />
		</g>
	</svg>

	<!-- Font Awesome overlays: endpoints and route icon (pure black) -->
	<!-- London (start) -->
	<div class="absolute" style="top: 34px; left: 22px; transform: translate(-50%, -50%); color:#000;">
		<i class={startIconClass} style="font-size:14px; line-height:1; color:#000; opacity:0.95;"></i>
	</div>

	<!-- Bicycle along the path -->
	<div class="absolute" style="top: 40px; left: 70px; transform: translate(-50%, -50%) rotate(10deg); color:#000;">
		<i class={routeIconClass} style="font-size:16px; line-height:1; color:#000; opacity:0.95;"></i>
	</div>

	<!-- Cape Town (end) -->
	<div class="absolute" style="top: 48px; left: 106px; transform: translate(-50%, -50%); color:#000;">
		<i class={endIconClass} style="font-size:14px; line-height:1; color:#000; opacity:0.95;"></i>
	</div>
</div>
